export default "__VITE_ASSET__CD_w7TIp__"